import { ReactElement } from 'react';

import { Bean, MoneyPatternType, ValidationRules } from '@dreryk/react-common';
import { MoneyInput, StyledMaxWidth } from '@dreryk/react-components';

import { refundAdvancePaymentTranslationKeys } from '../../translations';
import { RefundAdvancePaymentFormController } from '../RefundAdvancePaymentForm.types';

const t = refundAdvancePaymentTranslationKeys.form.fields.refundAmount;

const MIN_VALUE = 0.01;
const REFUND_AMOUNT_NAME = 'refundAmount';
const VALIDATION_RULES: ValidationRules<Bean> = {
   required: true,
   validate: (value, getValue) => {
      const advancePaymentAmount = getValue('advancePaymentAmount') as number;
      const refundAmount = value as number;

      if (refundAmount > advancePaymentAmount) {
         return t.validate.cannotBeGreaterThanAdvancePaymentAmount;
      }

      return undefined;
   },
};

type RefundAmountFieldProps = Pick<RefundAdvancePaymentFormController, 'register'>;

export const RefundAmountField = (props: RefundAmountFieldProps): ReactElement => {
   return (
      <StyledMaxWidth maxWidth={133}>
         <MoneyInput
            controller={props.register(REFUND_AMOUNT_NAME, VALIDATION_RULES)}
            label={t.label}
            pattern={MoneyPatternType.POSITIVE}
            testId={REFUND_AMOUNT_NAME}
            min={MIN_VALUE}
         />
      </StyledMaxWidth>
   );
};
